"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var virtualEntryConstants_exports = {};
__export(virtualEntryConstants_exports, {
  resolvedVirtualEntryId: () => resolvedVirtualEntryId,
  resolvedVirtualEntryIdNative: () => resolvedVirtualEntryIdNative,
  virtalEntryIdClient: () => virtalEntryIdClient,
  virtualEntryId: () => virtualEntryId,
  virtualEntryIdName: () => virtualEntryIdName,
  virtualEntryIdNative: () => virtualEntryIdNative
});
module.exports = __toCommonJS(virtualEntryConstants_exports);
var virtualEntryIdName = `one-entry`;
var virtualEntryId = `virtual:${virtualEntryIdName}`;
var virtalEntryIdClient = `/@id/__x00__virtual:${virtualEntryIdName}`;
var resolvedVirtualEntryId = "\0" + virtualEntryId;
var virtualEntryIdNativeName = `${virtualEntryIdName}-native`;
var virtualEntryIdNative = `virtual:${virtualEntryIdNativeName}`;
var resolvedVirtualEntryIdNative = "\0" + virtualEntryIdNativeName;
//# sourceMappingURL=virtualEntryConstants.js.map
